import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Мы используем файлы cookie',
    description:
      'Мы используем файлы cookie и похожие технологии для работы этого сервиса. Строго необходимые файлы cookie всегда активны.',
    allow_label: 'Принять все файлы cookie',
    reject_label: 'Только строго необходимые',
    settings_label: 'Настройки файлов cookie',
    policy_link_label: 'Политика конфиденциальности и файлов cookie',
    categories_label: 'Категории',
    always_on_label: 'Всегда активны',
    required_label: 'Обязательно',
    save_preferences_label: 'Сохранить настройки',
    close_label: 'Закрыть',
    allow_all_optional_categories_label: 'Разрешить все необязательные категории',
    save_error: 'Не удалось сохранить ваш выбор конфиденциальности. Повторите попытку.'
  },
  categories: {
    strictly_necessary: {
      name: 'Строго необходимые',
      purpose: 'Необходимы для работы этого сервиса и не могут быть отключены.'
    },
    analytics: {
      name: 'Аналитика',
      purpose: 'Измеряет, как посетители используют этот сервис, чтобы улучшить его работу.'
    },
    marketing: { name: 'Маркетинг', purpose: 'Поддерживает рекламу и маркетинг, выбранные организатором.' }
  }
};

export default locale;
